import React, { useEffect, useState } from "react";
import { Portal, Box, useDisclosure } from "@chakra-ui/react";

import Navbar from "./../Component/Navbar/Navbar";
import Sidebar from "./../Component/Sidebar/Sidebar";
import Routes from "./../assets/Data/Route";
import { useTranslation } from "react-i18next";

const Dashboard = (props) => {
  const [t] = useTranslation();

  const { ...rest } = props;
  const routes = Routes();

  const { onOpen } = useDisclosure();
  const [activePath, setActivePath] = useState(t("ACCOUNT"));

  const handleLinkClick = (path) => {
    setActivePath(path);
  };

  useEffect(() => {
    if (!activePath && routes.length > 0) {
      setActivePath(routes[0].path);
    }
  }, [activePath, routes]);

  const findComponent = (path, routes) => {
    for (const route of routes) {
      if (route.path === path) {
        return route.component;
      }
      if (route.subRoutes) {
        const component = findComponent(path, route.subRoutes);
        if (component) {
          return component;
        }
      }
    }
    return null;
  };

  const activeComponent = findComponent(activePath, routes);

  return (
    <div dir="rtl">
      <Sidebar
        routes={routes}
        onLinkClick={handleLinkClick}
        activePath={activePath}
      />

      <Box
        float="left"
        minHeight="100vh"
        height="100%"
        overflow="auto"
        position="relative"
        maxHeight="100%"
        w={{ base: "100%", xl: "calc(100% - 290px)" }}
        maxWidth={{ base: "100%", xl: "calc(100% - 290px)" }}
        transition="all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
      >
        <Portal>
          <Box>
            <Navbar
              routes={routes}
              onLinkClick={handleLinkClick}
              activePath={activePath}
              onOpen={onOpen}
              {...rest}
            />
          </Box>
        </Portal>

        <Box
          mx="auto"
          p={{ base: "10px", md: "10px" }}
          marginTop="80px"
          minH="50vh"
          pe="20px"
          pt="50px"
        >
          {activeComponent}
        </Box>
      </Box>
    </div>
  );
};

export default Dashboard;
